const FONT_STACK = [
	'Inter',
	'-apple-system',
	'BlinkMacSystemFont',
	'Segoe UI',
	'Roboto',
	'Helvetica Neue',
	'Arial',
	'Noto Sans',
	'sans-serif',
	'Apple Color Emoji',
	'Segoe UI Emoji',
	'Segoe UI Symbol',
	'Noto Color Emoji'
]
	.map((fontName) => (fontName.includes('') ? `"${fontName}"` : fontName))
	.join(', ');


class IminElement {
	constructor(provider) {
		const { checkout } = window?.lta?.[provider] || {};
		if (!Stripe) {
			// eslint-disable-next-line no-console
			console.error('The Stripe library has not been loaded into the page.');
		}

		if (provider === 'imin' && checkout) {
			this._stripe = Stripe(checkout.publishableKey, {
				stripeAccount: checkout.stripeAccount
			});
			const options = {
				clientSecret: checkout.clientSecret,
				appearance: {
					theme: 'none'
				}
			};
			this.elements = this._stripe.elements(options);
			this.paymentElement = this.elements.create('payment', {
				fields: {
					billingDetails: {
						address: {
							country: 'never'
						}
					}
				},

				defaultValues: {
					billingDetails: {
						address: {
							country: 'GB'
						}
					}
				}
			});

			this.paymentElement.mount('#card-payment-fields');
		}
	}
}

// eslint-disable-next-line consistent-return
export const getIminElementInstance = (provider) => {
	const { basket, checkout } = window?.lta?.[provider] || {};
	if (provider === 'imin' && !!basket?.totalCost && checkout && !checkout.element) {
		checkout.element = new IminElement(provider);
		return checkout.element;
	} else if (!provider) {
		return 'No provider found';
	}
};

export const elementClasses = {
	base: 'stripe-input-wrapper',
	empty: 'stripe-input-wrapper__empty',
	focus: 'stripe-input-wrapper__focus',
	invalid: 'stripe-input-wrapper__error'
};

export const elementStyles = {
	base: {
		'color': '#2D343C',
		'fontFamily': FONT_STACK,
		'fontSize': '16px',
		'::placeholder': {
			color: '#CDD4D8'
		}
	},
	invalid: {
		iconColor: '#DB3624',
		color: '#DB3624'
	}
};
